import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useAuthRedirect = (defaultDestination = "/signin") => {
	const navigate = useNavigate();
	const location = useLocation();

	return useCallback(
		(overrideDestination) => {
			const destination = overrideDestination || defaultDestination;
			const returnPath = `${location.pathname}${location.search}${
				location.hash || ""
			}`;
			if (typeof window !== "undefined") {
				localStorage.setItem("returnAfterSignIn", returnPath);
			}
			navigate(destination);
		},
		[
			defaultDestination,
			location.hash,
			location.pathname,
			location.search,
			navigate,
		]
	);
};

export default useAuthRedirect;
